module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('div', {
    staticClass: "figcenter",
    attrs: {
      "id": "il_1"
    }
  }, [_c('img', {
    staticClass: "calibre4",
    attrs: {
      "alt": " ",
      "id": "id-6117728965484537125",
      "src": "OEBPS/Images/3757041487943700252_i_001.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("A password was what he wanted, and Mr. Poincaré had forgotten\nto give me the correct one\n")])]), _vm._v(" "), _c('div', {
    staticClass: "calibre3"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16150024","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Section003.vue
// module id = 60
// module chunks = 0